import styled from 'styled-components';
import { Space } from 'antd';
import { PrimaryButton, RichTextEditor, SecondaryButton } from '@lib/common';
import { RequestStatus } from '@module/form';
import { useEffect, useRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledSpace = styled(Space).withConfig({
  displayName: "essay-answer-editor-editcomponent__StyledSpace",
  componentId: "sc-6tra1x-0"
})(["width:100%;display:flex;justify-content:space-between;color:black;margin-bottom:16px;"]);
var StyledButtonSpace = styled(Space).withConfig({
  displayName: "essay-answer-editor-editcomponent__StyledButtonSpace",
  componentId: "sc-6tra1x-1"
})(["width:100%;display:flex;justify-content:end;"]);
export var EssayAnswerEditorEditComponent = function EssayAnswerEditorEditComponent(_ref) {
  var questionIndex = _ref.questionIndex,
      value = _ref.value,
      onChange = _ref.onChange,
      onShowingUploadModal = _ref.onShowingUploadModal,
      onShowingAudioUploadModal = _ref.onShowingAudioUploadModal,
      updateAnswerStatus = _ref.updateAnswerStatus,
      disabledSaveButtonStatus = _ref.disabledSaveButtonStatus,
      onUpdateAnswer = _ref.onUpdateAnswer,
      onChangePreviewMode = _ref.onChangePreviewMode,
      onDeleteDraftAnswer = _ref.onDeleteDraftAnswer,
      file = _ref.file,
      updateFileAnswerStatus = _ref.updateFileAnswerStatus,
      editorLabels = _ref.editorLabels,
      label = _ref.label;
  var editorRef = useRef(null);
  var essayAnswerEditorEditId = "submission-question-".concat(questionIndex);
  useEffect(function () {
    if (updateFileAnswerStatus === RequestStatus.SUCCESS && editorRef.current && file) {
      editorRef.current.insertImageHandler(file.url);
    }
  }, [file, updateFileAnswerStatus, essayAnswerEditorEditId]);
  return /*#__PURE__*/_jsxs(StyledSpace, {
    size: 'small',
    direction: "vertical",
    children: [/*#__PURE__*/_jsx(RichTextEditor, {
      ref: editorRef,
      id: essayAnswerEditorEditId,
      content: value,
      onChange: onChange,
      addImage: onShowingUploadModal,
      addAudio: onShowingAudioUploadModal,
      editorLabels: editorLabels,
      placeholder: label.inputAnswer,
      scrollable: true
    }), /*#__PURE__*/_jsxs(StyledButtonSpace, {
      align: "baseline",
      children: [/*#__PURE__*/_jsx(SecondaryButton, {
        disabled: disabledSaveButtonStatus,
        onClick: function onClick() {
          onDeleteDraftAnswer();
          onChangePreviewMode();
        },
        children: label.cancel
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        size: "middle",
        disabled: disabledSaveButtonStatus,
        onClick: function onClick() {
          onDeleteDraftAnswer();
          onUpdateAnswer();
        },
        loading: updateAnswerStatus === RequestStatus.EXECUTE,
        children: label.save
      })]
    })]
  });
};